<template>
  <b-container fluid class="holder h-100 px-0" @keyup.esc="close">
    <div  class="container-fluid fill p-0">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center" v-if="!component.itemId && itemId !== 'new'"><b-spinner /></div>
    <div v-else>
    <b-row class="w-100 bg-white top-bar pl-3 d-flex align-items-center justify-content-between fill border-bottom">
        <b-col class="d-flex align-items-center py-2 w-100 justify-content-between">
          <div class="d-flex">
          <h5 class="m-0 pl-0" v-if="itemId === 'new'">New Item</h5>
          <h5 class="m-0 pl-0" v-else>Item {{ component.itemId }}</h5>
              <span class="mr-1 ml-3">{{ buildArtist(component) }}</span>
              <span class="mr-1 item-title">{{ buildFullTitle(component) }}</span>
              <span class="mr-1">{{ buildLabelName(component) }}</span>
              <span>{{ format({ item: component }, ' ') }}</span>
          </div>
          <div>
            <b-button v-b-modal.historyModal variant="outline-secondary" size="sm" class="mr-3" :disabled="itemId === 'new'">
                <b-icon-clock-history></b-icon-clock-history>
                <span class="ml-2 mr-1">History</span>
            </b-button>

            <b-button @click="createTemplateFromCurrent" variant="outline-secondary" size="sm" class="mr-3">
                <b-icon-file-earmark></b-icon-file-earmark>
                <span class="ml-2 mr-1">Template</span>
            </b-button>

            <search-site :item="component" :artist="buildArtist(component)" :title="buildTitle(component)"></search-site>
          </div>
        </b-col>
    </b-row>
    <b-container class="flex-grow-1 overflow-auto inventory-content" fluid v-if="itemFetched">
      <div>
        <b-row class="item-row">
            <b-col>
                <item-release
                  ref="itemRelease"
                  @dropNote="handleDrop($event)"
                  :item="component"
                  :release="component.release"
                  :itemNotes="hype || []"
                  @updateRelease="updateRelease($event)"
                  @updateNotes="updateHype($event)"
                  :noteDropped="noteDropped"
                ></item-release>
            </b-col> 
        </b-row>

        <b-row class="item-row mt-4 mb-4 px-3 justify-content-between align-items-center">
                <h5 class="pt-2 text-secondary">Listings</h5>
                <b-dropdown size="sm" variant="outline-secondary" toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <b-icon-caret-down></b-icon-caret-down>
                    </template>

                    <b-dropdown-item @click="addListing('active')">Active</b-dropdown-item>
                    <b-dropdown-item @click="addListing('inactive')">Inactive</b-dropdown-item>
                    <b-dropdown-item @click="addListing('cover')">Cover</b-dropdown-item>
                    <b-dropdown-item @click="addListing('disc')">Disc</b-dropdown-item>
                </b-dropdown>
        </b-row>

        <b-row class="item-row" :key="rowKey">
            <b-col v-for="(listing, index) in component.listing" :key="listing.uuid ? listing.uuid : listing._id" sm="12">
                <item-listing :listing="listing"
                              :index="index"
                              :itemId="component.itemId"
                              :mediaType="primaryMediaType()"
                              :mediaSpeed="primaryMediaSpeed()"
                              :mediaSize="primaryMediaSize()"
                              :allListings="component.listing"
                              @dropNote="handleDrop($event)"
                              @update="updateListing($event, index)"
                              @showImages="showImages($event)"
                              @removeListing="removeListing($event)"></item-listing>
            </b-col>
        </b-row>

        <b-row class="item-row">
            <b-col xl="7" lg="12">
                <internal-notes :notes="internal" @updateInternalNotes="updateInternalNotes($event)"></internal-notes>
            </b-col>

            <b-col>
                <suppressed :suppressed="component.suppressed" @update="updateSuppressed($event)"></suppressed>
            </b-col>
        </b-row>
         

            <b-modal centered
                     size="lg"
                     id="imageModal"
                     hide-footer
                     hide-header
                     v-model="showImageModal">
                <images :images="modalImages"></images>
            </b-modal>
      </div>          
    </b-container>
    </div>
  </div>
        <div class="bottomBar">
            <b-button class="mx-4" size="sm" :variant="hasChanges ? 'dark' : 'secondary'" @click="close">
                Close
            </b-button>
            <b-button class="saveButton" size="sm" :variant="saveButtonVariant" @click="saveItem"><span v-if="saving"><b-spinner small /></span><span v-else>{{saveButtonText}}</span></b-button>
        </div>
        
        <b-modal centered
                 size="lg"
                 id="historyModal"
                 hide-footer>
            <template #modal-header>
                <b-col>
                    <h5 class="mb-0 pt-2">History</h5>
                </b-col>
            </template>

            <item-history :item="component"></item-history>
        </b-modal>

 </b-container>
</template>

<script>

    import utils from "../mixins/utils";
    import ordersApi from "../api/orders";
    import inventoryApi from "../api/inventory";
    import ObjectMixin from "../mixins/object";
    import itemMixin from "../mixins/item";
    import SearchSite from "../components/inventory/SearchSite";
    import ItemHistory from "../components/inventory/ItemHistory";
    import ItemRelease from "../components/inventory/ItemRelease";
    import ItemListing from "../components/inventory/ItemListing";
    import InternalNotes from "../components/inventory/InternalNotes";
    import Suppressed from "../components/inventory/Suppressed";
    import Images from "../components/inventory/Images";
    import integrationPlatformOptions from "../assets/integrationPlatformOptions";
    import defaultInventoryItem from '../assets/defaultInventoryItem';
    import { uuid } from 'vue-uuid';

export default {
        name: "InventoryForm",
        components: { SearchSite, ItemHistory, ItemRelease, ItemListing, InternalNotes, Suppressed, Images },
        mixins: [ ordersApi, inventoryApi, ObjectMixin, utils, itemMixin, integrationPlatformOptions, defaultInventoryItem ],
        props: [ 'itemIdProp', 'templateItemProp' ],
        async beforeMount() {
          this.component = {};
        },
        deactivated() {
            window.removeEventListener('keydown', this.onKeyDown);
        },
        activated() {
            window.addEventListener('keydown', this.onKeyDown);
        },
        beforeDestroy() {
            // clean up values and event listeners
            this.component = {};
            this.originalItem = {};
            this.hasChanges = false;
            window.removeEventListener('keydown', this.onKeyDown);
        },
        async mounted() {
          window.addEventListener('keydown', this.onKeyDown);
          await this.initializeItem();
        },
        watch: {
        'component': {
          handler: 'checkChanges',
          deep: true,
          immediate: false,
        },
        templateItemProp: {
          handler(newVal, oldVal) {
            this.templateItem = newVal;
            // Re-initialize when template changes (e.g., when Template button is pressed in modal)
            // Only re-initialize if we're in 'new' mode and template actually changed
            if (newVal && this.itemId === 'new' && newVal !== oldVal) {
              this.$nextTick(() => {
                this.initializeItem();
              });
            }
          },
          immediate: true,
        },
        itemIdProp: {
          handler(newVal) {
            this.itemId = newVal;
            // Re-initialize when itemId changes (e.g., when switching to template)
            // Use nextTick to ensure templateItemProp watcher has run first
            if (newVal) {
              this.$nextTick(() => {
                this.initializeItem();
              });
            }
          },
          immediate: true,
        },
      },
        data() {
          return {
            itemLoading: false,
            hasChanges: false,
            itemFetched: false,
            component: {},
            originalItem: {},
            saving: false,
            recentlySaved: false,
            noteDropped: '',
            showImageModal: false,
            modalImages: [],
            confirmationOpen: false,
            hype: [],
            internal: [],
            rowKey: uuid.v1(),
            itemId: this.itemIdProp,
            templateItem: this.templateItemProp,
            includeLabelUsers: ['craig', 'kj', 'edward', 'jason.nickle', 'tim'],
          }
        },
        methods: {
          async initializeItem() {
            this.component = {};
            // Clear hype and internal before initializing to prevent old data from showing
            this.hype = [];
            this.internal = [];
            this.itemLoading = true;
            this.itemFetched = false;
            let item = null;
            if (this.itemId === 'new') {
              // Use template item if provided, otherwise use default
              if (this.templateItem) {
                // Template item is already clean (built from defaultInventoryItem with only platforms)
                // Just clone it as-is - no need to clear integrations again
                item = this.deepClone(this.templateItem);
                // Ensure notes are empty for templates (don't add defaultHype)
                item.notes = [];
                // Ensure label is empty (don't copy label or catalog number)
                if (item.release) {
                  if (!this.includeLabelUsers.includes(this.$auth.user.nickname)) {
                    item.release.label = {
                      name: '',
                      catalogNo: ''
                    };
                  }
                }

                if (this.$auth.user.nickname === 'jamin') {
                  item.listing[0].source = null;
                }
              } else {
                item = this.defaultInventoryItem;
                let defaultHype = localStorage.getItem('inventoryHype') || null;
                if (defaultHype) {
                  item.notes.push({
                    text: defaultHype,
                    username: this.$auth.user.nickname,
                    date: Date.now(),
                  });
                }
              }
              let defaultSource = localStorage.getItem('inventorySource') || null;
              let defaultLocation = localStorage.getItem('inventoryLocation') || null;
              let defaultOffsite = localStorage.getItem('inventoryOffsite') || false;
              let date = Date.now();
              item.listing[0].username = this.$auth.user.nickname;
              item.listing[0].date = date;
              if (defaultSource || defaultLocation || defaultOffsite) {
                item.listing[0].source = defaultSource;
                item.listing[0].location = defaultLocation;
                item.listing[0].offsite = defaultOffsite;
                item.listing[1].location = defaultLocation;
              }
            } else {
              item = await this.getItem(this.itemId);
            }

            // Template items are already clean - no need to clear integrations again
            const isTemplate = this.itemId === 'new' && this.templateItem;
            
            if (item && item.release?.integrations?.length < this.integrationPlatforms.length) {
                  this.integrationPlatforms.forEach(platform => {
                      if (!item.release.integrations.find(i => i.platform === platform.value)) {
                          item.release.integrations.push({platform: platform.value});
                      }
                  });
            }
            if (item) {
              const deeplyClonedCopy = this.deepClone(item);
              
              // For template items, ensure label is empty (integrations already clean from template creation)
              if (isTemplate && deeplyClonedCopy.release) {
                if (!this.includeLabelUsers.includes(this.$auth.user.nickname)) {
                  deeplyClonedCopy.release.label = {
                    name: '',
                    catalogNo: ''
                  };
                }
              }
              
              item && this.clone(deeplyClonedCopy);

              // order release.integrations: Discogs, Amazon, Amazon UK
              if (this.component.release?.integrations) {
                this.component.release.integrations.sort((a, b) => {
                  return this.integrationPlatforms.findIndex(p => p.value === a.platform) - this.integrationPlatforms.findIndex(p => p.value === b.platform);
                });
              }
              
              // For template items, ensure label is still empty (integrations already cleared before clone)
              if (isTemplate && this.component.release) {
                if (!this.includeLabelUsers.includes(this.$auth.user.nickname)) {
                this.component.release.label = {
                    name: '',
                    catalogNo: ''
                  };
                }
              }
              
              if (isTemplate && this.$auth.user.nickname === 'jamin') {
                this.component.listing[0].source = null;
              }

              this.itemFetched = true;
            }
            // Split notes into 'hype' and 'internal'
            // For templates, ensure notes are empty (check both itemId and templateItem)
            let notes = item?.notes || [];
            // isTemplate already declared above, reuse it
            if (isTemplate) {
              // This is a template item - force notes to be empty
              notes = [];
              // Also ensure item.notes is empty
              if (item) {
                item.notes = [];
              }
            }
            const hype = notes.filter(note => !note.type) || [];
            const internal = notes.filter(note => note.type === 'internal') || [];
            // Explicitly clear and set hype/internal to ensure UI updates
            this.hype = [];
            this.internal = [];
            this.hype = [...hype];
            this.internal = [...internal];
            // Set notes in component
            this.component.notes = [...hype, ...internal];
            // For template flows, move focus to Title for jamin
            if (isTemplate && this.$auth.user.nickname === 'jamin') {
              this.$nextTick(() => {
                const itemRelease = this.$refs.itemRelease;
                const titles = itemRelease && itemRelease.$refs && itemRelease.$refs.titles;
                if (titles && typeof titles.focusFirstTitle === 'function') {
                  titles.focusFirstTitle();
                }
              });
            }
            
            // For templates, ensure integrations are empty (same pattern as notes)
            if (isTemplate && this.component.release) {
              // Force integrations to be empty - rebuild from scratch with only platforms
              this.component.release.integrations = this.integrationPlatforms.map(platform => ({
                platform: platform.value
              }));
            }
            
            // HACK -- for items that don't have an artist
            if (!this.component.release?.artist) {
                this.component.release.artist = {
                    first: '',
                    last: ''
                }
            }
            this.itemLoading = false;
            // Set originalItem AFTER all component modifications are complete
            // This ensures they match and prevents false "unsaved changes" detection
            this.$nextTick(() => {
              this.originalItem = this.deepClone(this.component);
              this.hasChanges = false;
            });
          },
          async saveItem() {
            if (this.itemId !== 'new' && !this.isUnderpriced(this.component)) {
                this.showError({ message: 'Too cheap! Check the price.' }, 'Inventory Error');
                return;
              } else {
                try {
                  this.saving = true;
                  let data = this.deepClone(this.component);
                  delete data.__v;
                  let updatedItem;
                  if (this.itemId === 'new') {
                    if (!this.isUnderpriced(this.component) && !window.confirm('Price is too low. Create anyway?')) {
                        return; // If the user cancels, do nothing
                    }
                    updatedItem = await this.createItem(data);
                    this.component = updatedItem;
                    this.itemId = this.component.itemId;
                    // Emit event to update parent's itemId so Template button can work for the saved item
                    this.$emit("itemSaved", this.component.itemId);
                  } else {
                    updatedItem = await this.updateEntireItem(this.component.itemId, data);
                    this.component = updatedItem.data;
                  }
                  this.recentlySaved = true;
                  // set the component with updated data


                  setTimeout(() => {
                    this.recentlySaved = false;
                  }, 2000);
                } catch (error) {
                  this.showError(error, 'Inventory Error');
                  this.saving = false;
                  console.log(error);
                } finally {
                    this.rowKey = uuid.v1();
                    // update the original item with new component state
                    this.originalItem = this.deepClone(this.component);
                    this.checkChanges();
                    this.saving = false;
                }
              }
          },
          close() {
            // If there are unsaved changes, open the confirmation dialog
            if (this.hasChanges && !window.confirm('You appear to have unsaved changes. Are you sure you want to close?')) {
                return; // If the user cancels, do nothing
            }
            // If either there are no unsaved changes or the user confirms, reset component data and emit the close event
            this.itemFetched = false;
            this.component = {};
            this.$emit("closeItem");
          },
          async createTemplateFromCurrent() {
            // Check for unsaved changes
            if (this.hasChanges) {
              const proceed = window.confirm('You have unsaved changes. Create template anyway? (Unsaved changes will be lost)');
              if (!proceed) {
                return; // User cancelled, don't create template
              }
              // User confirmed, proceed with template creation (discarding unsaved changes)
            }

            // Create template item with Artist, Title, Genre, and Media from current item
            const defaultSource = localStorage.getItem('inventorySource') || null;
            const defaultLocation = localStorage.getItem('inventoryLocation') || null;
            
            // Deep clone the default inventory item structure (starts with clean integrations)
            const templateItem = this.deepClone(this.defaultInventoryItem);
            
            // Copy Artist
            if (this.component.release?.artist) {
              templateItem.release.artist = {
                first: this.component.release.artist.first || '',
                last: this.component.release.artist.last || ''
              };
            }
            
            // Copy Title
            if (this.component.release?.titles) {
              templateItem.release.titles = [...this.component.release.titles];
            }
            
            // Copy Genre
            if (this.component.release?.genres) {
              templateItem.release.genres = this.component.release.genres.map(genre => ({
                name: genre.name
              }));
            }
            
            // Copy Media
            if (this.component.release?.media) {
              templateItem.release.media = this.component.release.media.map(media => ({
                count: media.count || 1,
                attributes: media.attributes ? [...media.attributes] : [],
                size: media.size || null,
                duration: media.duration || null,
                speed: media.speed || null
              }));
            }
            
            // Apply defaults (location, source)
            const date = Date.now();
            templateItem.listing[0].username = this.$auth.user.nickname;
            templateItem.listing[0].date = date;
            if (defaultSource || defaultLocation) {
              templateItem.listing[0].source = defaultSource;
              templateItem.listing[0].location = defaultLocation;
              templateItem.listing[1].location = defaultLocation;
            }
            
            // Clear notes/hype - don't copy from original item
            templateItem.notes = [];
            
            // Label: clear for most users; for includeLabelUsers, copy from current item
            if (templateItem.release) {
              if (this.includeLabelUsers.includes(this.$auth.user.nickname) && this.component.release?.label) {
                templateItem.release.label = {
                  name: this.component.release.label.name || '',
                  catalogNo: this.component.release.label.catalogNo || ''
                };
              } else {
                templateItem.release.label = {
                  name: '',
                  catalogNo: ''
                };
              }
              // Rebuild integrations from scratch with only platforms - don't map, completely rebuild
              // This ensures no IDs are copied, matching the toolbar template behavior
              templateItem.release.integrations = this.integrationPlatforms.map(platform => ({
                platform: platform.value
              }));
            }
            
            // Emit event to parent to switch to the template without closing the modal
            this.$emit("switchToTemplate", templateItem);
          },
          onKeyDown(event) {
            if ((event.metaKey || event.ctrlKey) && event.key === 's') {
                event.preventDefault(); // Prevent browser's default action
                this.saveItem();
            }

            if (event.key === 'Escape' || event.keyCode === 27) {
              event.preventDefault();
              this.close();
            }
          },
          update(key, updatedValue) {
            this.$set(this.component, key, updatedValue);
          },
          updateRelease(obj) {
            const key = obj.key;
            const value = obj.obj;
            const updatedRelease = { ...this.component.release };
            updatedRelease[key] = value;
            this.$set(this.component, 'release', updatedRelease);
          },
          checkChanges() {
            // Only check for changes if item is loaded and originalItem is set
            // Also ensure component is fully initialized
            if (this.itemLoading || !this.itemFetched || Object.keys(this.originalItem).length === 0 || Object.keys(this.component).length === 0) {
              this.hasChanges = false;
              return;
            }
            this.hasChanges = !this.isEqual(this.component, this.originalItem);
          },
          isUnderpriced() {
            if (!this.component.listing) {
              return true;
            }

            for (let i = 0; i < this.component.listing.length; i++) {
              let l = this.component.listing[i];
              if (l.type === 'active' && (parseInt(l.price) < 4 || !l.price)) {
                  return false;
              }
            }

            return true;
          },
          format(data, separator = ' ') {
                if (!data.item?.release?.media.length || !data.item?.release?.media[0].size) {
                    return ``;
                }

                if (data.item.release?.media[0].size === '12') {
                    if (data.item?.release?.media[0].duration === 'Single') {
                        return '12'
                    } else if (data.item.release?.media[0].duration === 'LP') {
                        return 'LP';
                    } else {
                        return data.item.release?.media[0].duration;
                    }
                } else if (data.item.release.media[0].size === '10') {
                    if (data.item.release.media[0].speed === '78') {
                      return '78';
                    }
                    return '10';
                } else if (data.item.release.media[0].size === '7') {
                    if (data.item.release.media[0].duration === 'EP') {
                        return 'EP'
                    } else {
                        return '45';
                    }
                } else if (data.item.release.media[0].size === '5') {
                    return 'CD';
                } else if (data.item.release.media[0].size === '4') {
                    return 'Cassette';
                }

                if (data.item?.release?.media?.length) {
                    let size = data.item.release.media[0].size;
                    let count = data.item.release.media[0].count;

                    if (count > 1) {
                        size = `${count}x${size}`;
                    }

                    let format = `${size}" ${data.item.release.media[0].duration}`;

                    format += separator;

                    if (data.item.release.media[1]) {
                        format += `...`;
                    }

                    return format;
                }
            },
            showImages(images) {
                this.modalImages = images;
                this.showImageModal = true;
            },
            handleDrop(event) {
                this.noteDropped = event;
                console.log(this.noteDropped, 'dropped note');
            },
            addListing(type) {
                let date = Date.now();
                let listing = {
                    type: type,
                    count: 1,
                    location: null,
                    price: 0,
                    condition: [{
                        subject: null,
                        grade: null,
                    }],
                    images: [],
                    soundclips: [],
                    username: this.$auth.user.nickname,
                    date: date,
                    uuid: uuid.v1(),
                };
                const newArray = [...this.component.listing];
                newArray.push(listing);
                this.$set(this.component, 'listing', newArray);
            },
            removeListing(index) {
              const newListings = [...this.component.listing.slice(0, index), ...this.component.listing.slice(index + 1)];
              this.$set(this.component, 'listing', newListings);
            },
            updateListing(updatedListing, index) {
                this.$set(this.component.listing, index, updatedListing);
            },
            updateSuppressed(newSuppressed) {
                if (!this.component.suppressed) {
                  this.$set(this.component, 'suppressed', [])
                }
                this.$set(this.component, 'suppressed', newSuppressed);
            },
            updateNotes() {
              const notes = [...this.hype, ...this.internal];
              this.component.notes = notes;
            },
            updateInternalNotes(data) {
              this.internal = data;
              this.updateNotes();
            },
            updateHype(data) {
              this.hype = data;
              this.updateNotes();
            },
            primaryMediaSpeed() {
                if (this.component.release.media.length > 0 && this.component.release.media[0].speed) {
                    return this.component.release.media[0].speed;
                }
                return null;
            },
            primaryMediaSize() {
                if (this.component.release.media.length > 0 && this.component.release.media[0].size) {
                    return this.component.release.media[0].size;
                }
                return null;
            },
            primaryMediaType() {
                if (this.component.release.media.length > 0 && this.component.release.media[0].duration) {
                    return this.component.release.media[0].duration;
                }
                return null;
            },

        },
        computed: {
          saveButtonVariant() {
            if (this.recentlySaved) {
                return 'primary';
            } else if (this.hasChanges) {
                return 'success';
            } else {
                return 'secondary';
            }
          },
          saveButtonText() {
            if (this.itemId === 'new') {
              return 'Create Item'
            } else if (this.recentlySaved) {
              return 'Saved!'
            } else {
              return 'Save Changes'
            }
            
          }
        }

      }
</script>


<style scoped>


  .order-col {
    max-width: 680px;
  }

  .item-row {
    max-width: 1300px;
  }

  .saveButton {
    width: 110px;
  }

  .top-bar {
    z-index: 4;
    position: fixed;
    top: 40px;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 10px;
    padding-right: 30px;
    padding-left: 10px;
  }
  .bottomBar {
    z-index: 100;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background-color: rgba(173, 171, 171, 0.291);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 40px;
    backdrop-filter: blur(20px);
  }

  .inventory-content {
    padding-top: 60px;
    padding-bottom: 90px;
    max-height: calc(100vh - 100px);
  }

  .scroller {
    overflow-y: auto;
  }

  .order-item-row {
    max-width: 1200px;
  }

  .item-title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  
  .shadowNone.btn-outline-secondary:active,
  .shadowNone.btn-outline-secondary:focus,
  .shadowNone.btn-outline-secondary.active,
  .shadowNone.btn-outline-secondary:active:focus {
    background-image: none;
    outline: 0;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
</style>
